<template>
  <v-dialog :value="dialog" max-width="550" persistent>
    <v-card>
      <v-form v-on:submit.prevent="confirm">
        <v-card-title>
          <span class="headline">{{ payslips.length == 1 ? "Publicar recibo" : "Publicar recibos" }}</span>
        </v-card-title>

        <v-card-text>
          <p v-if="payslips.length == 1" class="mb-2">
            Se publica el recibo <b>{{ periodLabel(payslips[0]) }}</b> de <b>{{ legajoLabel(payslips[0].legajo) }}</b>.
          </p>
          <p v-else class="mb-2">
            Se publican <b>{{ publishable.length }}</b> recibos.
          </p>
          <p v-if="publishable.length < payslips.length" class="mb-2 orange--text text--darken-3">
            {{ payslips.length - publishable.length }} de los seleccionados no se pueden publicar (no están en borrador o no tienen
            legajo) y se omiten.
          </p>
          <p class="mb-4">Cada empleado recibe un aviso por email y en la aplicación.</p>

          <v-radio-group v-model="mode" class="mt-0">
            <v-radio label="Publicar ahora" value="now"></v-radio>
            <v-radio label="Programar para una fecha" value="scheduled"></v-radio>
          </v-radio-group>

          <div v-if="mode == 'scheduled'" class="row">
            <div class="col-md-6">
              <v-menu v-model="menu_date" :close-on-content-click="false" transition="scale-transition" offset-y
                min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="formatDate(date)" label="Fecha*" name="date" data-vv-as="fecha"
                    v-validate="'required'" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="date" locale="es" :min="today" @input="menu_date = false"></v-date-picker>
              </v-menu>
              <span class="red--text">{{ errors.first("date") }}</span>
            </div>
            <div class="col-md-6">
              <v-text-field v-model="time" type="time" label="Hora*" name="time" data-vv-as="hora" v-validate="'required'"></v-text-field>
              <span class="red--text">{{ errors.first("time") }}</span>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text :disabled="loading" @click="close">Cancelar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading" :disabled="publishable.length == 0">
            {{ mode == "now" ? "Publicar" : "Programar" }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";
import { periodLabel, legajoLabel, formatDate } from "@/constants/payslips";

// Publicar ahora o programar uno o varios recibos (los que no se pueden publicar se omiten)
export default {
  props: {
    dialog: Boolean,
    payslips: { type: Array, default: () => [] },
  },
  data() {
    return {
      mode: "now",
      date: null,
      time: "08:00",
      menu_date: false,
      loading: false,
      periodLabel: periodLabel,
      legajoLabel: legajoLabel,
    };
  },
  computed: {
    publishable() {
      return this.payslips.filter((payslip) => payslip.can_publish);
    },
    today() {
      const today = new Date();
      today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      return today.toISOString().substr(0, 10);
    },
  },
  watch: {
    dialog(value) {
      if (!value) return;
      this.mode = "now";
      this.date = null;
      this.time = "08:00";
      this.$validator.reset();
    },
  },
  methods: {
    formatDate(date) {
      return date ? formatDate(date) : "";
    },
    close() {
      this.$emit("updateDialog", false);
    },
    async confirm() {
      if (this.loading || !(await this.$validator.validate())) return;

      const param = { ids: this.payslips.map((payslip) => payslip.id) };
      if (this.mode == "scheduled") param.scheduled_at = this.date + " " + this.time;

      this.loading = true;
      payslipService
        .publish(param)
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.close();
            this.$emit("saved");
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrió un error al publicar los recibos.", "Error");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
